import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button-group',
  standalone: true,
  imports: [CommonModule, InputWrapperComponent],
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ButtonGroupComponent),
      multi: true
    }
  ]
})
export class ButtonGroupComponent implements ControlValueAccessor {
  @Input() options: { label: string; value: any }[] = [];
  @Input() disabled = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: string = 'primary';
  @Input() buttonClass = '';

  @Input() ariaLabel: string = '';

  @Input() label?: string;
  @Input() required?: boolean;
  @Input() errorMessage?: any;
  @Input() touched?: boolean;

  @Output() valueChange = new EventEmitter<any>();

  value: any;
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(val: any): void {
    this.value = val;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  select(option: any) {
    if (this.disabled) return;
    this.value = option.value;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
    this.onTouched();
  }

  isSelected(option: any) {
    return this.value !== undefined && this.value === option.value;
  }
}
